import { render, staticRenderFns } from "./wxlogoff.vue?vue&type=template&id=177134da&scoped=true"
import script from "./wxlogoff.vue?vue&type=script&lang=js"
export * from "./wxlogoff.vue?vue&type=script&lang=js"
import style0 from "./wxlogoff.vue?vue&type=style&index=0&id=177134da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177134da",
  null
  
)

export default component.exports